/* eslint-disable require-jsdoc */
import {isValid} from '../../utils/validate';

const dayChoiceForDb = (chosenDay, todaysDate, futureDates) => {
  const todayDate=typeof todaysDate ==='function' ?
  todaysDate() : todaysDate;

  const futureDate=isValid(futureDates) ?
    futureDates(chosenDay) : chosenDay;

  const day = `min_date=${todayDate}&max_date=${futureDate}`;

  // console.log('chosenDay in dayChoiceForDb', chosenDay);
  // console.log('moment currentDateTime', currentDateTime);
  // console.log('filterChoiceForDb day',day);
  return day;
};

const genreChoiceForDb = (chosenGenre) => {
  // console.log('chosenGenre in genreChoiceForDb', chosenGenre);
  if (chosenGenre!== '-1' && chosenGenre!=='') {
    const genre = '&genre='+ chosenGenre;
    return genre;
  } else {
    // console.log('we are in genreChoiceForDb else loop!');
    return '';
  }
};

const sortChoiceForDb = (chosenSort) => {
  // console.log('chosenSort in sortChoiceForDb', chosenSort);
  const sort = 'sort='+ chosenSort;
  return sort;
};

const searchChoiceForDb = (chosenSearch) => {
  // console.log('chosenSearch in sortChoiceForDb', chosenSearch);
  const search=chosenSearch ? '&search='+ chosenSearch : '';

  // const search = '&sort='+ chosenSearch;
  return search;
};

export {sortChoiceForDb, genreChoiceForDb, dayChoiceForDb, searchChoiceForDb};
